import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { AbsenceCategoryEnum } from '@wilson/absences';
import { Absence } from '@wilson/interfaces';
import { DragAndDropModeService } from '@wilson/shift-timeline/services';
import { SetDemarcatorRange } from '@wilson/shift-timeline/state';
import { FORBID_EDITING_ABSENCE_CATEGORIES_IDS } from '@wilson/non-domain-specific/absence';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable()
export class MoveAbsenceDropZoneHelperService {
  private readonly dragAndDropModeService = inject(DragAndDropModeService);
  private readonly store = inject(Store);
  private readonly modalService = inject(NzModalService);
  private readonly translate = inject(TranslateService);

  public startDrag(absence: Absence): boolean {
    const isForbiddenToEditAbsenceCategory =
      this.isForbiddenToEditAbsenceCategory(absence);

    if (isForbiddenToEditAbsenceCategory) {
      this.restrictAbsenceDrag();
      return false;
    } else {
      this.dragAndDropModeService.setDisplayTimeVisible(true);
      setTimeout(() => {
        this.dragAndDropModeService.setDraggingAbsence(
          absence as Absence & { id: string; isHighlighted: boolean },
        );
      });
      return true;
    }
  }

  public dragEnd(isMoveMode: boolean) {
    if (isMoveMode) {
      this.dragAndDropModeService.setDisplayMovingDemarcatorLine(true);
      this.dragAndDropModeService.setIsMovingItemLeftRight(false);
    }
    this.store.dispatch(new SetDemarcatorRange([]));
    this.dragAndDropModeService.setTimeDifferenceVisible(true);
    this.dragAndDropModeService.setShiftDropZoneVisible(true);
    this.dragAndDropModeService.setAbsenceDropZone(false);
    this.dragAndDropModeService.setDisplayTimeVisible(false);
    this.dragAndDropModeService.setHorizontalDemarcatorRange({
      left: null,
      right: null,
      shiftDuration: null,
      adjustmentNeeded: true,
    });
  }

  public initiateDragAndDrop(left: number | null, right: number | null) {
    if (left && right) {
      this.store.dispatch(
        new SetDemarcatorRange([
          {
            left,
            right,
          },
        ]),
      );
    }
    this.dragAndDropModeService.setDisplayMovingDemarcatorLine(true);
    this.dragAndDropModeService.setAbsenceDropZone(true);
    this.dragAndDropModeService.setTimeDifferenceVisible(false);
    this.dragAndDropModeService.setShiftDropZoneVisible(false);
    this.dragAndDropModeService.setIsMovingItemLeftRight(true);
    this.dragAndDropModeService.setDisplayTimeVisible(true);
  }

  public isForbiddenToEditAbsenceCategory(absence: Absence) {
    return FORBID_EDITING_ABSENCE_CATEGORIES_IDS.includes(
      absence.absenceCategoryId as AbsenceCategoryEnum,
    );
  }

  public restrictAbsenceDrag() {
    this.modalService.info({
      nzTitle: this.translate.instant('shift-plan.edit-absence'),
      nzContent: this.translate.instant(
        'page.shift_timeline.absence_drag.sick_leave_or_vacation',
      ),
      nzOkText: this.translate.instant('general.ok'),
      nzOkType: 'primary',
      nzOkDanger: false,
    });
  }
}
